// Small formatting helpers used across the UI.

const numFmt = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const compactFmt = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 2,
});

export function fmtPrice(v) {
  if (v == null || Number.isNaN(v)) return "—";
  return numFmt.format(v);
}

export function fmtPct(v) {
  if (v == null || Number.isNaN(v)) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${numFmt.format(v)}%`;
}

export function fmtSignedNum(v) {
  if (v == null || Number.isNaN(v)) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${numFmt.format(v)}`;
}

export function fmtVolume(v) {
  if (v == null || Number.isNaN(v)) return "—";
  return compactFmt.format(v);
}

export function fmtWeight(v) {
  if (v == null || Number.isNaN(v)) return "—";
  return `${numFmt.format(v)}%`;
}

export function pickTrendColor(v) {
  if (v == null || Number.isNaN(v)) return "text-muted-soft";
  if (v > 0) return "text-positive";
  if (v < 0) return "text-negative";
  return "text-muted-soft";
}
